<template>
  <main>
    <ProductDescription/>

    <Preloader v-if="!stock._id"/>
    <PrizeList
      v-else
      :title="stock.name"
      :description="stockDate"
      :items="prizesBySelectedStock"
      @play="onClickPlay"
    />
  </main>
</template>


<script>
import PrizeList from './prize/List';
import Preloader from '@/components/game/Preloader';
import ProductDescription from '@/components/game/ui/ProductDescription';
import { mapGetters, mapActions, mapMutations } from 'vuex';

export default {
  name: 'AppGame_ViewLobby',

  emits: ['changeView'],

  components: {
    Preloader,
    ProductDescription,
    PrizeList,
  },

  computed: {
    ...mapGetters([
      'prizesBySelectedStock',
      'selectedStock',
    ]),

    stock: ths => ths.selectedStock || {},
    stockDate() {
      const start = this.convertDate(this.stock.start_date);
      const end = this.convertDate(this.stock.end_date);
      return `${start} - ${end}`;
    },
  },

  mounted() {
    this.checkGameDuration();
    this.$store.dispatch('updateSubscription');
  },

  methods: {
    ...mapActions(['checkGameDuration']),
    ...mapMutations(['setGameViewId']),

    onClickPlay() {
      this.$router.push('/play');
    },

    convertDate(unix) {
      const date = new Date(unix);
      const day = date.getDate().toString().padStart(2, 0);
      const month = (date.getMonth() + 1).toString().padStart(2, 0);
      const year = date.getFullYear().toString().slice(-2);
      return `${day}.${month}.${year}`;
    },
  },
};
</script>
